import { Text, Box } from '@chakra-ui/react'
import type { FC } from 'react'
import { useMemo } from 'react'

import { useColorModeValue } from '@app/components/ui/color-mode'
import CardSection from '@app/shared/cards/components/cardSection'
import type { MetricSource } from '@graphql/types'

type Props = {
  metricSource: Pick<MetricSource, 'structuredFormula'>
}

const CardFormula: FC<Props> = ({ metricSource }) => {
  const text = useMemo(() => {
    const texts = metricSource?.structuredFormula?.map((item) => {
      if (item.__typename === 'FormulaText') {
        return item.text
      }

      return item.name
    })

    if (!texts || texts.length === 0) {
      return ''
    }

    return texts.join(' ')
  }, [metricSource?.structuredFormula])

  const bgColor = useColorModeValue('gray.50', 'gray.700')

  if (!text || text.trim() === '') {
    return null
  }

  return (
    <CardSection>
      <Box bgColor={bgColor} p={2} borderRadius="md" fontFamily="mono">
        <Text fontSize="sm" letterSpacing="wide">
          {text}
        </Text>
      </Box>
    </CardSection>
  )
}

export default CardFormula
